// extracted by mini-css-extract-plugin
export default {"activityTrend":"style_activityTrend__-KBhW","amount":"style_amount__OO1Ko","text":"style_text__TWM-I","trendData":"style_trendData__kv-XR"};